import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@knockrentals/knock-shared-web-v2';
import { ColorSwatch } from '../../../../../../../../../Components/Icons';
import { makeCss } from '../../../../../../../../../knock-design-system';

const useCss = makeCss({
  colorSwatch: {
    height: '48px',
    width: '48px',
  },
  swatchWrapper: {
    textAlign: 'center',
  },
});

const BrandColorSwatch = ({ brandColor }) => {
  const css = useCss();

  return (
    <div css={css.swatchWrapper}>
      <ColorSwatch css={css.colorSwatch} color={brandColor} />
      <Typography color="text.tertiary" variant="caption">
        {brandColor}
      </Typography>
    </div>
  );
};

BrandColorSwatch.propTypes = {
  brandColor: PropTypes.string,
};

export default BrandColorSwatch;
